"use strict";
/**
 * 用户级别,币对层级的,底层配置
 * 比如 ats 滑点配置, 该币对的交易手续费
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserSymbolConfig = void 0;
const react_1 = require("react");
const factory_1 = require("./factory");
const useUserSymbolConfig = (symbol) => {
    const [config, setConfig] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const sub = factory_1.UserSymbolConfigManager.getPublish(symbol).subscribe({
            next: setConfig,
            error: (error) => setConfig({ error }),
        });
        return () => {
            sub.unsubscribe();
        };
    }, [symbol]);
    return Object.assign({}, config);
};
exports.useUserSymbolConfig = useUserSymbolConfig;
